import {
  Dashboard,
  AddToQueue,
  People,
  AccessTime,
  Settings,
  WorkOutline,
  Build,
  Business
} from "@mui/icons-material";
import SwitchAccountIcon from "@mui/icons-material/SwitchAccount";
import StoreIcon from "@mui/icons-material/Store";
import PreviewIcon from "@mui/icons-material/Preview";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import FollowTheSignsIcon from "@mui/icons-material/FollowTheSigns";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import HailIcon from "@mui/icons-material/Hail";
import DirectionsRunIcon from "@mui/icons-material/DirectionsRun";
import ScreenSearchDesktopIcon from "@mui/icons-material/ScreenSearchDesktop";
import SettingsIcon from "@mui/icons-material/Settings";
import VerifiedUserIcon from "@mui/icons-material/VerifiedUser";

export const menuList = [
  { icon: <Dashboard />, label: "Dashboard", path: "/" },
  {
    icon: <PeopleAltIcon />,
    label: "Employee",
    subMenu: [
      // { label: "Create Employee", path: '/create-employee', icon: <AddCircleOutlineIcon /> },
      {
        label: "Employee Profile",
        path: "/view-employee",
        icon: <SwitchAccountIcon />
      }
    ]
  },
  // { icon: <SettingsIcon />, label: "Master", subMenu: [
  //   { label: "User", path: '/user-role' },
  //   { label: "Role", path: '/role-creation' },
  // ] },
  { icon: <FollowTheSignsIcon />, path: "/leave", label: "Leaves" },
  { icon: <AccessTime />, path: "/attendance-info", label: "Attendance" },
  {
    icon: <Settings />,
    label: "Settings",
    subMenu: [
      {
        label: "Company Setup",
        path: "/view-companySetup",
        icon: <StoreIcon />
      }
    ]
  }
];

export const errorMessages = {
  numberSeries: "Employee series is requierd",
  name: "Full Name is required.",
  nameInvalid: "Full Name is invalid.",

  employeeNumber: "Employee Number is required.",
  employeeNumberInvalid: "Employee Number is invalid.",

  email: "Email is required.",
  emailInvalid: "Invalid email format.",

  phoneNumber: "Phone Number is required.",
  phoneNumberInvalid: "Phone Number should be 10 digits.",

  gender: "Gender is required.",
  aadhar: "Aadhaar number is required.",
  reportingManager: "Reporting manager is required.",
  status: "Status is required.",
  department: "Department is required.",
  dateOfJoin: "Date of joining is required",
  position: "Position is required.",
  probation: "Probation period is required.",
  dateOfConfirmation: "Confirmation date is required",
  fatherName: "Father's name is required.",
  spouseName: "Spouse name is required.",
  address: "Address is required.",

  dateOfBirth: "Date of Birth is required.",
  dateOfBirthInvalid: "Invalid Date of Birth.",

  emergencyContact: "Emergency Contact is required.",
  emergencyContactInvalid: "Invalid Emergency Contact number.",

  skills: "Skills are required."
};

export const createUserSteper = [
  "EMPLOYEE INFORMATION",
  "CONTACT INFORMATION",
  "ASSIGNMENT",
  "IDENTIFICATION",
  "BANK INFORMATION",
  "COMPENSATION",
  "FAMILY DETAILS",
  "EMPLOYEE ADDITIONAL SECTION",
  "QUALIFICATIONS"
];

export const columns = [
  {
    id: 1,
    key: "employeeNumber",
    label: "Emp Code",
    name: "employeeNumber"
  },
  { id: 2, key: "name", label: "Name", name: "name" },
  { id: 3, key: "gender", label: "Gender", name: "gender" },
  { id: 4, key: "status", label: "Status", name: "status" },
  { id: 5, key: "dateOfJoin", label: "Date of Join", name: "dateOfJoin" },
  {
    id: 6,
    key: "dateOfConfirmation",
    label: "Date of Confirmation",
    name: "dateOfConfirmation"
  }
];

export const dashboardUsers = [
  {
    label: "Total Employee",
    status: "Employee",
    count: "50",
    icon: <PeopleAltIcon />,
    bg: "#635BFF"
  },
  {
    label: "Employee Present Today",
    status: "Present",
    count: "45",
    icon: <HailIcon />,
    bg: "#15B79F"
  },
  {
    label: "Employee Absent Today",
    status: "Absent",
    count: "5",
    icon: <DirectionsRunIcon />,
    bg: "#FB9C0C"
  },
  {
    label: "Total Projects",
    status: "Project Status",
    count: "7",
    icon: <ScreenSearchDesktopIcon />,
    bg: "#635BFF"
  }
];

export const employeeDepartment = [
  { label: "Human Resource", count: 3, color: "#ff6384" },
  { label: "Marketing", count: 6, color: "#36a2eb" },
  { label: "Business Analyst", count: 5, color: "#cc65fe" },
  { label: "UI/UX Designer", count: 8, color: "#ffce56" },
  { label: "Testing", count: 12, color: "#4bc0c0" },
  { label: "Developers", count: 30, color: "#9966ff" }
];

export const employeeStatus = [
  { label: "Active", count: 40, color: "#36a2eb" },
  { label: "Inactive", count: 10, color: "#ff6384" },
  { label: "On Leave", count: 5, color: "#9966ff" }
];

export const monthlyActivityData = [
  { month: "January", joined: 15, left: 3, promoted: 5 },
  { month: "February", joined: 18, left: 4, promoted: 6 },
  { month: "March", joined: 20, left: 2, promoted: 8 },
  { month: "April", joined: 22, left: 3, promoted: 7 },
  { month: "May", joined: 30, left: 1, promoted: 10 },
  { month: "June", joined: 25, left: 5, promoted: 9 },
  { month: "July", joined: 28, left: 2, promoted: 11 },
  { month: "August", joined: 35, left: 4, promoted: 12 },
  { month: "September", joined: 40, left: 3, promoted: 15 },
  { month: "October", joined: 45, left: 6, promoted: 16 },
  { month: "November", joined: 50, left: 7, promoted: 18 },
  { month: "December", joined: 60, left: 4, promoted: 20 }
];

export const monthlyEmployeeData = [
  { month: "January", HR: 10, Developers: 25, QA: 15, Marketing: 12, Sales: 8 },
  {
    month: "February",
    HR: 12,
    Developers: 30,
    QA: 18,
    Marketing: 14,
    Sales: 10
  },
  { month: "March", HR: 14, Developers: 28, QA: 20, Marketing: 16, Sales: 12 }
  // { month: 'April', HR: 15, Developers: 32, QA: 22, Marketing: 18, Sales: 14 },
  // { month: 'May', HR: 16, Developers: 34, QA: 25, Marketing: 20, Sales: 16 },
];

export const relationships = [
  "Father",
  "Mother",
  "Sister",
  "Brother",
  "Spouse",
  "Child"
];

export const employeeTabs = [
  "Employee information",
  "Contact Information",
  "Assignment",
  "Identification",
  "Bank Information",
  "Compensation",
  "Family Details",
  "Employee Additional",
  "Qualifications"
];

export const loginInActiveError =
  "User in Inactive Stage.Can you Please reset your Password or Contact your Admin";

export const clubitsLogo = "https://salmon-sand-08dfb5700.4.azurestaticapps.net/static/media/logo.bfc32458a914a0298e62996bedf3286a.svg"